const SDK_STORAGE_KEYS = {
  TOKEN: "sdk_token",
  CALLBACK: "sdk_callback",
  SERVICE_TYPE: "sdk_service_type",
  REQUEST_ID: "sdk_request_id",
} as const;

export const setSdkStorage = (token: string, callback: string, serviceType: string, requestId?: string): void => {
  try {
    localStorage.setItem(SDK_STORAGE_KEYS.TOKEN, token);
    localStorage.setItem(SDK_STORAGE_KEYS.SERVICE_TYPE, serviceType);

    if (callback) {
      localStorage.setItem(SDK_STORAGE_KEYS.CALLBACK, callback);
    }

    if (requestId) {
      localStorage.setItem(SDK_STORAGE_KEYS.REQUEST_ID, requestId);
    }
  } catch (error) {
    console.error("Error setting SDK storage:", error);
  }
};

export const getSdkToken = (): string | null => {
  try {
    return localStorage.getItem(SDK_STORAGE_KEYS.TOKEN);
  } catch (error) {
    console.error("Error getting SDK token:", error);
    return null;
  }
};

export const getSdkCallback = (): string | null => {
  try {
    return localStorage.getItem(SDK_STORAGE_KEYS.CALLBACK);
  } catch (error) {
    console.error("Error getting SDK callback:", error);
    return null;
  }
};

export const getSdkServiceType = (): string | null => {
  try {
    return localStorage.getItem(SDK_STORAGE_KEYS.SERVICE_TYPE);
  } catch (error) {
    console.error("Error getting SDK service type:", error);
    return null;
  }
};

export const getSdkRequestId = (): string | null => {
  try {
    return localStorage.getItem(SDK_STORAGE_KEYS.REQUEST_ID);
  } catch (error) {
    console.error("Error getting SDK request ID:", error);
    return null;
  }
};

export const clearSdkStorage = (): void => {
  try {
    localStorage.removeItem(SDK_STORAGE_KEYS.TOKEN);
    localStorage.removeItem(SDK_STORAGE_KEYS.CALLBACK);
    localStorage.removeItem(SDK_STORAGE_KEYS.SERVICE_TYPE);
    localStorage.removeItem(SDK_STORAGE_KEYS.REQUEST_ID);
  } catch (error) {
    console.error("Error clearing SDK storage:", error);
  }
};

export const hasSdkStorage = (): boolean => {
  try {
    const token = localStorage.getItem(SDK_STORAGE_KEYS.TOKEN);
    const serviceType = localStorage.getItem(SDK_STORAGE_KEYS.SERVICE_TYPE);
    return !!(token && serviceType);
  } catch (error) {
    console.error("Error checking SDK storage:", error);
    return false;
  }
};
